import { useEffect, useRef, useState } from 'react';
import { localToday } from '../utils/fitnessProgress';
import { loadFitnessProgress, type FitnessProgressResult } from '../utils/fitnessProgressData';

/** Cache belongs to this mounted panel, so another login cannot inherit athlete data. */
export function useFitnessProgress(userId: number | null | undefined, refreshKey = 0, retry = 0) {
  const today = localToday();
  const [state, setState] = useState<{ id: number; today: string; result: FitnessProgressResult } | null>(null);
  const [loading, setLoading] = useState(false);
  const requestRef = useRef<{ key: string; at: number; request: Promise<FitnessProgressResult> } | null>(null);
  useEffect(() => {
    if (!userId) return;
    let active = true;
    const key = JSON.stringify([userId, today, refreshKey, retry]);
    const cached = requestRef.current;
    const request = cached?.key === key && Date.now() - cached.at < 120_000
      ? cached.request : loadFitnessProgress(userId, today);
    requestRef.current = { key, at: Date.now(), request };
    setLoading(true);
    void request.then(result => {
      if (active) { setState({ id: userId, today, result }); setLoading(false); }
    });
    return () => { active = false; };
  }, [userId, today, refreshKey, retry]);
  const current = state && state.id === userId && state.today === today ? state.result : null;
  return { ...current, today, loading: !!userId && (loading || !current) };
}
